import { AxiosResponse, AxiosError } from 'axios';
import axiosApiInstance from '../request';

const postFcmTokenService = async (fcmToken: string) => {
  const headers = { 'Content-Type': 'application/json' };
  const payload = {
    fcm_token: fcmToken
  };
  try {
    const response: AxiosResponse = await axiosApiInstance.post(`/user-fcm-token/`, payload, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};

const getFcmTokenService = async () => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const response: AxiosResponse = await axiosApiInstance.get(`/user-fcm-token/`, {
      headers
    });
    return response.data[0];
  } catch (error) {
    throw error as AxiosError;
  }
};

const putFcmTokenService = async (id: string, fcmToken: string) => {
  const headers = { 'Content-Type': 'application/json' };
  const payload = {
    fcm_token: fcmToken
  };
  try {
    const response: AxiosResponse = await axiosApiInstance.put(`/user-fcm-token/${id}/`, payload, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};
const postNotificationService = async (payload: any) => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const response: AxiosResponse = await axiosApiInstance.post(`/notifications/`, payload, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};

const getNotificationService = async () => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const response: AxiosResponse = await axiosApiInstance.get(`/notifications/`, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};

const updateNotificationService = async (id: string, payload: any) => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const response: AxiosResponse = await axiosApiInstance.put(`/notifications/${id}/`, payload, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};

const deleteNotificationService = async (id: string) => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const response: AxiosResponse = await axiosApiInstance.delete(`/notifications/${id}/`, {
      headers
    });
    return response.data;
  } catch (error) {
    throw error as AxiosError;
  }
};

export {
  postFcmTokenService,
  getFcmTokenService,
  putFcmTokenService,
  getNotificationService,
  updateNotificationService,
  postNotificationService,
  deleteNotificationService
};
